/** Portal target for DevMessaging panels inside the shared dev overlay stack. */
export const DEV_OVERLAY_MESSAGING_SLOT_ID = "csk-dev-overlay-messaging";
